import React from 'react';

import Loader from 'react-loader-spinner'

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

const PageLoader = ({ showSpinner }) => {
  return (
    showSpinner ? (
      <div id="cover-spin">
        <div className="loadingSpinner">
          <Loader type="Bars" color="#324ea8" height={100} width={100} />
        </div>
      </div>
    ) : (<></>)
  );
};

export default PageLoader;